import {ComponentWithoutChildren} from '../../react/types';
import {TextButton, TextButtonProps} from './TextButton';

export type CloseButtonProps = Omit<TextButtonProps, 'i18nKey'>;

export const CloseButton: ComponentWithoutChildren<CloseButtonProps> = ({...muiProps}: CloseButtonProps) => {
  return <TextButton {...muiProps} i18nKey="common:button.close" />;
};
